const Data = {
    key : "5ecb6039e4efb5befc701a2a3d056045",
    UNSPLASH_API_KEY: "JJk61014LSGvE7rTHWucZJGa6DmE9_h-5Kw5kv8bdyg"
};

export default Data;